var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChargebacks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4904_39251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4576 3.79102V9.74935C12.4576 10.3452 11.9701 10.8327 11.3742 10.8327H2.16589C2.16589 10.291 2.16589 10.3452 2.16589 9.74935H11.3742V3.79102C11.9701 3.79102 11.9159 3.79102 12.4576 3.79102Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0014019 2L-0.000772476 7.5C-0.000772476 8.09583 0.486729 8.58333 1.08256 8.58333H10.2909C10.2909 8.04167 10.2909 8.09583 10.2909 7.5H1.08256L1.08193 2C0.486099 2 0.540265 2 -0.0014019 2Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3213 8.7148L12.4608 8.7149L12.5 3.70731L11.5985 2.00098L8.44427 5.15523L9.07512 5.78608L11.3606 3.70721L11.3213 8.7148Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06513 6.71284L-0.0742885 6.71294L-0.113502 1.70536L0.787959 -0.000971435L3.94221 3.15328L3.31136 3.78413L1.06513 1.70536L1.06513 6.71284Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99988 4.625C3.99988 3.72583 4.72571 3 5.62488 3C6.52404 3 7.24988 3.72583 7.24988 4.625C7.24988 5.52417 6.52404 6.25 5.62488 6.25C4.72571 6.25 3.99988 5.52417 3.99988 4.625Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4904_39251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargebacks);
export default __webpack_public_path__ + "static/media/chargebacks.832931c7578d95cb700754d1b69e9be1.svg";
export { ForwardRef as ReactComponent };